import { MovieMinusOutlineIcon } from './MovieMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 44B3B4FB-C569-4D4D-A463-C2F6B87A584C
 * name movie-minus-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-minus-outline.svg
 * tags
 * - Video / Movie 
 */
export const FilmMinusOutlineIcon = MovieMinusOutlineIcon;
export default FilmMinusOutlineIcon